import { render, staticRenderFns } from "./fourthfourth.vue?vue&type=template&id=88e0c984&"
import script from "./fourthfourth.vue?vue&type=script&lang=js&"
export * from "./fourthfourth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e0c984')) {
      api.createRecord('88e0c984', component.options)
    } else {
      api.reload('88e0c984', component.options)
    }
    module.hot.accept("./fourthfourth.vue?vue&type=template&id=88e0c984&", function () {
      api.rerender('88e0c984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fourth/fourthfourth.vue"
export default component.exports